import React from 'react';

import { Button } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

export default class Notification extends React.PureComponent {
  render() {
    const { message, cta = false } = this.props;

    const classes = cx(styles.notification, {
      [styles.cta]: cta,
    });

    const msg = message.split(' --- ').map((m, i) => <div key={`notificationline${i}`}>{m}</div>);

    return (
      <div className={classes}>
        <div className={styles.message}>{msg}</div>
        {cta ? <Button className={styles.button} {...cta} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/notification/index.js